import { Outlet } from 'react-router-dom';
import { FeatureFlagNameEnum } from '@keyops-cep/api-client';

import Loading from '../../components/Loading';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import NotFound from '../../pages/NotFound';

type Props = {
  feature: FeatureFlagNameEnum;
};

// NOTE: If different feature-flagged routes require different fallback behavior,
// we can refactor this to accept a fallback component or route as a prop
// and render it accordingly, allowing flexible fallbacks per route.
const FeatureFlagRoute = ({ feature }: Props) => {
  const { data: flags, isLoading } = useFeatureFlags();

  // While loading or flags are undefined, show Loading
  if (isLoading || flags === undefined || flags[feature] === undefined)
    return <Loading />;

  // Only show NotFound if the feature is explicitly disabled
  if (flags[feature] === false) return <NotFound />;

  return <Outlet />;
};

export default FeatureFlagRoute;
